import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './index.css'
import { useAuthStore } from './stores/auth'
import { useThemeStore } from './stores/themeStore'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Écouteur d'événement pour réinitialiser tous les stores
window.addEventListener('pinia-reset-stores', () => {
  // Récupérer tous les stores enregistrés dans Pinia
  const storeIds = Object.keys(pinia.state.value)
  
  for (const storeId of storeIds) {
    if (storeId !== 'auth') { // Ne pas réinitialiser le store d'authentification
      try {
        const store = pinia._s.get(storeId)
        if (store && typeof store.$reset === 'function') {
          store.$reset()
        }
      } catch (error) {
        console.error(`Erreur lors de la réinitialisation du store ${storeId}:`, error)
      }
    }
  }
})

// Initialiser l'état d'authentification
const authStore = useAuthStore()
authStore.initializeAuth()
// Configurer explicitement les intercepteurs Axios pour l'authentification
authStore.setupAxiosInterceptors()

// Initialiser le thème
const themeStore = useThemeStore()
themeStore.initializeTheme()

app.mount('#app')

